/**
 * Human labels for `OrderTag.tag` values returned by staff + CRM APIs.
 * Keep in sync with `order.models.OrderTag.TAG_CHOICES` (dropit_backend).
 */
export const SLA_TAG_LABELS: Record<string, string> = {
  packing_late: 'Packing',
  billing_late: 'Billing',
  picking_late: 'Picking',
  reached_late: 'Reaching',
  return_late: 'Returning',
  delivery_late: 'Delivery handover',
  return_entry_late: 'Return entry',
  return_racking_late: 'Return racking',
  rider_returned_to_store_late: 'Rider returned to store',
  cancelled: 'Cancelled',
};

export function slaTagLabel(tag: string | null | undefined): string {
  if (!tag) return 'SLA';
  return SLA_TAG_LABELS[tag] ?? tag.replace(/_/g, ' ');
}
